<template>
  <div
    class="game-card"
    :class="{ 'active': active }"
    @click="onCardClick"
    @mouseenter="onMouseEnter"
    @mouseleave="onMouseLeave"
  >
    <div v-if="game.brand_game_category_id.includes('HOT')" class="game-info-icon-hot">
      HOT
    </div>
    <div v-if="game.brand_game_category_id.includes('NEW')" class="game-info-icon-new">
      NEW
    </div>
    <div class="game-card-name">
      <div class="game-tx">
        <div class="game-name name-tex">
          {{ game.name }}
        </div>
        <div class="game-provider">
          <img :src="providerImage" alt="">
        </div>
      </div>
      <!-- data-game-feedback：收藏成功後的短暫回饋動畫（樣式見 refresh/game-content.css） -->
      <div class="game-info" :data-game-feedback="favoriteFeedback">
        <i class="game-info-icon" />
        <i
          v-if="token"
          class="game-info-icon-heart-show"
          :class="{ active: game.isFavorite }"
          @click.stop="onFavoriteClick"
        />
        <i
          v-if="isNoBonusGame(game)"
          class="game-info-icon-nobonus-show"
        />
      </div>
    </div>
    <div class="game-card-image">
      <div class="img-mask" :class="{ 'D-none': isTheme('theme_neotri') }" />
      <d-img :src="game" :alt="game.name" />
    </div>

    <div class="game-card-info">
      <div class="game-info-bn">
        <button @click.stop="$emit('launch', game)">
          {{ $t("Bao.play_game_now") }}
        </button>
        <button v-if="game.demo_url" @click.stop="$emit('demo', game)">
          {{ $t('Bao.demo') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import dImg from '@/components/dynamicImg'
import { detectMob } from '@/utils/tool'
import themeMixin from '@/mixins/themeMixin'

export default {
  name: 'GameCard',
  components: {
    dImg
  },
  mixins: [themeMixin],
  props: {
    game: {
      type: Object,
      required: true
    },
    // 是否已登入，控制愛心與點擊行為
    token: {
      type: [String, Boolean],
      default: false
    },
    // 是否為目前 hover 的卡片
    active: {
      type: Boolean,
      default: false
    },
    // 供應商圖片（由父層解析後傳入）
    providerImage: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      favoriteFeedback: null,
      favoritePending: false
    }
  },
  watch: {
    // 收藏 API 成功後 isFavorite 才會改變；只有這張卡片發起的變更才播放回饋，失敗時不會觸發
    'game.isFavorite'(isFavorite) {
      if (!this.favoritePending) return
      this.favoritePending = false
      this.showFavoriteFeedback(isFavorite ? 'added' : 'removed')
    }
  },
  beforeDestroy() {
    clearTimeout(this.favoriteFeedbackTimer)
  },
  methods: {
    onFavoriteClick() {
      this.favoritePending = true
      this.$emit('favorite', this.game)
    },
    showFavoriteFeedback(value) {
      // 同切版 game-interactions.js：重設計時器，減少動態效果時不播放
      clearTimeout(this.favoriteFeedbackTimer)
      this.favoriteFeedback = null
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return
      this.favoriteFeedback = value
      this.favoriteFeedbackTimer = setTimeout(() => {
        this.favoriteFeedback = null
      }, 440)
    },
    // 遊戲的 support_wallet_type 沒有支援 bonus 錢包時，顯示禁止贈金的小圖示
    isNoBonusGame(game) {
      return Array.isArray(game.support_wallet_type) && !game.support_wallet_type.includes('bonus')
    },
    // 未登入也送出 launch，由 launchGameWithProviderInfo 開啟登入彈窗
    onCardClick() {
      this.$emit('launch', this.game)
    },
    onMouseEnter() {
      if (!detectMob() && !this.token) {
        this.$emit('hover', this.game.id)
      }
    },
    onMouseLeave() {
      if (!detectMob() && !this.token) {
        this.$emit('hover', null)
      }
    }
  }
}
</script>
